/** How often to re-fetch the credit balance while the AI Tooling tab is open. */
export const CREDIT_BALANCE_POLL_INTERVAL_MS = 3 * 60 * 1000;

/** Stop automatic balance polling after this many background refreshes. */
export const CREDIT_BALANCE_MAX_POLL_COUNT = 10;

export const API_KEY_NAME_MIN_LENGTH = 3;
export const API_KEY_NAME_MAX_LENGTH = 64;

export const API_KEYS_ROWS_PER_PAGE = 5;

export const installedAIApps = [
  'openclaw',
  'claudecode',
  'hermes',
  'nanoclaw',
  'gatorclaw',
];

export const aiCreditArticleUrlMap: Record<string, string> = {
  openclaw: 'openClawAiCreditArticleUrl',
  claudecode: 'claudeCodeAiCreditArticleUrl',
  hermes: 'hermesAiCreditArticleUrl',
  nanoclaw: 'nanoClawAiCreditArticleUrl',
  gatorclaw: 'gatorClawAiCreditArticleUrl',
};

export const SUPPORTED_AI_BRANDS = ['bluehost', 'hostgator'] as const;
export type AiBrand = (typeof SUPPORTED_AI_BRANDS)[number];
export const DEFAULT_AI_BRAND: AiBrand = 'bluehost';

export const aiAppDisplayNameMap: Record<string, string> = {
  openclaw: 'OpenClaw',
  claudecode: 'Claude Code',
  hermes: 'Hermes Agent',
  nanoclaw: 'NanoClaw',
  gatorclaw: 'GatorClaw',
};
